import { RolesEnum } from 'infrastructure/enums/RolesEnum';
import { useContextSelector as useCS } from 'use-context-selector';
import { GlobalConfigContext } from 'domain/globalConfig/GlobalConfigContext';
import { globalConfigSelectors } from 'domain/globalConfig/selectors';
import * as S from './styled';

const ChatsListHeader = ({ total }) => {
  const { role } = useCS(GlobalConfigContext, globalConfigSelectors.userData);
  return (
    <S.ChatsListHeader>
      <S.ChatsListHeaderTitle>
        Chats <span>({total})</span>
      </S.ChatsListHeaderTitle>
      <S.ChatsListHeaderDesc>
        {role?.name === RolesEnum.JOB_SEEKER
          ? 'Your conversations with employers \n will appear here.'
          : 'Your candidate conversations will appear here.'}
      </S.ChatsListHeaderDesc>
    </S.ChatsListHeader>
  );
};

export default ChatsListHeader;
